// Job 81 — client-side half of the archive vocabulary. The database predicate is
// the real gate (see billService and the server read paths); every read path
// filters in Postgres, so this module intentionally stops at `isArchived` rather
// than also providing an in-memory list filter that nothing calls.

export type ArchiveScope = 'active' | 'archived' | 'all';

/** The shape this module needs. Anything with the column satisfies it. */
export type ArchivableBill = { archived_at?: string | null };

export function isArchived(bill: ArchivableBill): boolean {
  return bill.archived_at != null;
}
